/**
 * created by lei lei
 *
 */
import React from 'react';
import {Modal, Icon, Input, Divider, Upload, Button, Tooltip} from 'antd';
import {message} from "../../sysManagement/utils/sysManagementUtils";
import Editors from '../../../view/components/editor/Editors';
import {Scrollbars} from "react-custom-scrollbars";
import BaseComponent from "../../../base/BaseComponent";
import './weiboList.css';
import LinkCheck from "../../editor/components/pluginsSpace/linkCheck/linkCheck"
import SecurityCheck, {
    addContentSecurityByText,
    formatItem,
    removeContentSecurity
} from "../component/securityCheck/securityCheck";
export default class Headlines extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            initWeiBoId: 0,
            title: '',
            summary: '',
            content: '',//头条内容
            isUpDate: false,
            cover: '',//封面图
            contents: '',//微博主体内容
            labelNames: [],//标签名字
            timingTransmission: '',//定时发送的时间暂存,
            currentData: {},//微博所有的数据

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    render() {
        let footer = [
            <Button type="primary" onClick={() => {
                this.nextBtn()
            }}>下一步</Button>
        ];
        let color = "unset";
        if(typeof this.securityCheck?.renderCheckBtn === "function") {
            color = this.securityCheck.renderCheckBtn({btnType:"color"});
            let btn = <Button id={"checkBtn-toutiao"} type="primary" onClick={() => {this.onCheckBtn()}}>安全检测</Button>;
            footer.push(btn)
        }
        return (
            <div>
                <style>
                {`
                .headlines .ant-modal-header .ant-modal-title{font-family: "微软雅黑";font-weight: bold;}
                .headlines .ant-modal-close{color: rgba(0, 0, 0, 0.85);}
                #checkBtn-toutiao {background-color: ${color} !important;border-color: ${color} !important;}
                `}
                </style>
                <Modal
                    className={"headlines"}
                    title="头条文章"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    centered={true}
                    width={"auto"}
                    bodyStyle={{padding:0}}
                    footer={footer}
                    maskClosable={false}
                >
                    <div style={{display: "flex"}} id={"headlines_content"}>
                        {this.renderLeft()}
                        {this.count > 0 ? (
                            this.renderRight()
                        ) : ""}
                    </div>
                </Modal>
                <LinkCheck  ref={(LinkCheck)=>{this.LinkCheck=LinkCheck}}/>
                <SecurityCheck ref={ref=>this.securityCheck=ref} noInfoCheckRecord={this.state.noInfoCheckRecord}/>
            </div>
        )
    }

    renderRight = () => {
        let SENSITIVE = 0;
        let OUTSIDE_CHAIN = 0;
        let config = [
            {
                name: "标题区域",
                key: "title",
                checkList: []
            },
            {
                name: "文章摘要区域",
                key: "summary",
                checkList: []
            },
            {
                name: "文章正文区域",
                key: "content",
                checkList: []
            },
        ];
        for(let i in this.checkData) {
            let item = this.checkData[i];
            if(item?.length) {
                for(let k=0;k<item.length;k++) {
                    let Item = item[k];
                    if(Item?.category === "OUTSIDE_CHAIN") {
                        OUTSIDE_CHAIN++
                    } else {
                        SENSITIVE++
                    }
                    let find = config.find(item=>item.key===i);
                    if(find?.checkList?.push) {
                        find.checkList.push(formatItem(Item))
                    }
                }
            }
        }
        return (
            <div style={{
                display: "flex",
                width:416,
                flexDirection: "column",
                height: 625,
                borderLeft: "1px solid #e8e8e8",
                fontSize:12,
            }}>
                <div style={{flex:1,height: "100%",padding: 24}}>
                    <Scrollbars style={{height: "100%",width:"100%"}}>
                        <div title={"统计区"} style={{padding:12,background:"#fff9f9",height:91,border: "1px solid #fee",fontSize:14,borderRadius: "5px"}}>
                            <div>当前文章</div>
                            <div>敏感信息：<span style={{color:"#dc7e77"}}>{SENSITIVE}</span> 条</div>
                            <div>疑似外链：<span style={{color:"#e6ad5d"}}>{OUTSIDE_CHAIN}</span> 条</div>
                        </div>
                        {
                            config.map(item=>{
                                if(item.checkList?.length) {
                                    return (
                                        <div key={item?.key} title={item?.name} style={{marginTop:16}}>
                                            <div style={{width: 367,height: 32,display: "flex",alignItems: "center",paddingLeft: 8,background: "#ebf1f9",fontSize:14,}}>{item?.name}</div>
                                            <div style={{dispaly:"flex"}}>
                                                {
                                                    item.checkList.map((item,index) => {
                                                        return (<div key={index} style={{padding: "12px 8px"}}>
                                                            {item}
                                                        </div>)
                                                    })
                                                }
                                            </div>
                                        </div>
                                    )
                                }
                                return ""
                            })
                        }
                    </Scrollbars>
                </div>
                <div style={{
                    height:40,
                    borderTop: "1px solid #e8e8e8",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}>
                    <Button id={"againCheck"} onClick={this.onCheckBtn}>再次检测</Button>
                    <style>
                        {
                            `
                            #againCheck {
                                color: rgba(0, 0, 0, 0.65) !important;
                            }
                            `
                        }
                    </style>
                </div>
            </div>
        )
    };

    renderLeft = () => {
        const uploadButton = (
            <div>
                <Icon type={this.state.loading ? 'loading' : 'plus'}/>
                <div className="ant-upload-text">设置封面</div>
            </div>
        );
        const upload = {
            name: "file",
            listType: "picture-card",
            accept: '.png,.jpg,.gif,.jpeg,.bmp,.webp,.webp2',
            showUploadList: false,
            beforeUpload: (file) => {
                const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/jpg' || file.type === 'image/webp' || file.type === 'image/webp2' || file.type === 'image/bmp' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'application/pdf';
                if (!isJpgOrPng) {
                    message.error('暂不支持该文件类型，请上传图片类型文件！');
                }
                const isLt2M = file.size / 1024 / 1024 <= 10;
                if (!isLt2M) {
                    message.error('图片大小必须不超过10MB！');
                }
                return isJpgOrPng && isLt2M;
            },
            customRequest: ({file}) => {
                let url = "/storage/uploadFile";
                let fd = new FormData();
                fd.append("file", file);
                this.request({
                    url,
                    body: fd,
                    method: "post",
                    contentType: "upload",
                    callBack: (file) => {
                        let that = this;
                        if (file) {
                            let cover = file.path ? file.path : null;
                            that.setState({
                                cover,
                                loading: false,
                            })
                        }
                    }
                });
            }
        }
        const {cover} = this.state;
        return (
                <div style={{padding:24}}
                     className={"headLineInput"}
                >
                    <style>{`.headLineInput .ant-input{border: 0;}`}</style>
                    <div id={"weiboInput"} style={{
                        display: 'flex',
                        height: 34,
                        width: 880,
                        border: "1px solid rgba(0, 80, 179, 0.08)",
                        borderRadius: "2px"
                    }}>
                        <div>
                            <Input placeholder={'请输入标题'}
                                   style={{width: 820, backgroundColor: "rgba(0, 80, 179, 0.04)",}}
                                   maxLength={32}
                                   value={this.state.title}
                                   onChange={(e) => {
                                       this.onChangeByCheck();
                                       this.setState({title: e.target.value})
                                   }}
                            />
                        </div>
                        <div style={{
                            lineHeight: '34px',
                            paddingLeft: 20,
                            width: 100,
                            backgroundColor: "rgba(0, 80, 179, 0.04)",
                        }}>{this.state.title.length}/32
                        </div>
                    </div>
                    <div id={"weiboInput"} style={{
                        display: 'flex',
                        marginTop: 20,
                        height: 34,
                        width: 880,
                        border: "1px solid rgba(0, 80, 179, 0.08)",
                        borderRadius: "2px"
                    }}>
                        <div><Input placeholder="请输入导语" style={{width: 820, backgroundColor: "rgba(0, 80, 179, 0.04)",}}
                                    maxLength={44}
                                    value={this.state.summary}
                                    onChange={(e) => {
                                        this.onChangeByCheck();
                                        this.setState({summary: e.target.value})
                                    }}
                        /></div>
                        <div
                            style={{
                                lineHeight: '34px',
                                paddingLeft: 20, backgroundColor: "rgba(0, 80, 179, 0.04)", width: 100
                            }}>{this.state.summary.length}/44
                        </div>
                    </div>
                    <div style={{width: 880, marginTop: 20}}>
                        <Editors
                            customHeight={220}
                            imgBtnShow={true}
                            content={this.state.content}
                            isUpDate={this.state.isUpDate}
                            dataSourceType={7}
                            callBackeditorContent={(data) => {
                                if(!this.state.isUpDate && this.state.content!==data) {
                                    this.onChangeByCheck();
                                }
                                this.setState({content: data, isUpDate: false})
                            }}
                            ref={ref=>this.editors=ref}
                            sensitiveCheck={false}
                            onCheck={this.onCheckBtn}
                            renderSensitiveCheck={this.renderCheck}
                        />
                    </div>
                    <Divider style={{fontSize: 12, color: '#808080', paddingRight: "20px"}}>发布设置</Divider>
                    <div style={{display: 'flex'}}>
                        <div style={{fontSize: 16, color: '#333333'}}><span style={{color: "red"}}>*</span>设置封面</div>
                        <div style={{marginLeft: 20}}>
                            <Upload {...upload}>
                                <div>
                                    {
                                        cover ?
                                            <img src={cover} alt="avatar" style={{
                                                maxWidth: '128px',
                                                maxHeight: '128px',
                                                objectFit: 'cover'
                                            }}/> : uploadButton
                                    }
                                </div>
                            </Upload>
                        </div>
                    </div>
                </div>
        )
    };

    onChangeByCheck = (call) => {
        if(typeof this.securityCheck?.setCheckStatus === "function") {
            this.securityCheck.setCheckStatus("change",()=>{
                this.setState({})
            })
        }
    };

    onCheck = (call) => {
        message.destroy();
        if(typeof this.securityCheck.asyncCheck === "function") {
            this.getCheckData(({contents,data,key})=>{
                this.securityCheck.asyncCheck({contents,data,key,
                    call:(res)=>{
                        call&&call(res)
                    }
                });
            });
        } else {
            message.warning("敏感词检测失效，无法进行异步检测");
        }
    };

    getCheckData = (call) => {
        if(!(
            (this.state.title?.length && this.state.title.trim()?.length)
            || (this.state.summary?.length && this.state.summary.trim()?.length)
            || (this.state.content?.length && this.state.content.trim()?.length)
        )) {
            message.warning("请输入内容后再进行检测");
            return false
        }
        let contents = {
            title: this.state.title,
            summary: this.state.summary,
            content: removeContentSecurity(this.state.content),
        };
        let data = {
            contents,
            data: {
                "id": this.state.initWeiBoId || "",
                // "check_info_url": "/cm-sites-pms/weibo/getById?id="+this.weiboId,
                "storyName": this.state.title || "",
                // "storyStatusName": this.state.currentItem.statusName || "",
                // "mediaName": this.state.currentItem.mediaName || this.state.mediaName,
                "createUserName": window.currentUser?.name || "",
                "deptName": window.currentUser?.defaultInfo?.dept?.name || "",
                "createStoryUserName": window.currentUser?.name || "",
                "createStorydeptName": window.currentUser?.defaultInfo?.dept?.name || "",
                // "createStoryMediaName": this.state.currentItem.mediaName || this.state.mediaName,
            },
            key: this.state.initWeiBoId || "",
        };
        call&&call(data)
    };

    onCheckBtn = () => {
        this.onCheck((res)=>{
            let msg = res?.msg;
            switch (res?.code) {
                case 0:
                    // 没有敏感词
                    message.success(msg || "未检测到敏感信息");
                    break;
                case 1:
                    // 检测到敏感词
                    message.warning(msg || "检测到敏感信息");
                    break;
                case -1:
                    // 检测报错
                    message.error(msg || "敏感词检测失败");
                    break;
                default:
                    // 未知错误
                    message.warning(msg || "敏感词检测失效，无法进行异步检测");
            }
            this.checkData = res.data;
            this.showCheckResult();
        })
    };
    checkData={};
    renderCheck = () => {
        if(typeof this.securityCheck?.renderCheckBtn === "function") {
            let icon = this.securityCheck.renderCheckBtn({btnType:"icon"});
            let {count,checkStatus} = this.securityCheck.getCheckResult(["count","checkStatus"]);
            let num = "";
            if(checkStatus === "over" && count > 0) {
                num = count > 9 ? "9+" : count
            }
            return `<div style="vertical-align: middle;position: relative;line-height: 40px;width: 40px;text-align: center;cursor: pointer;">
                <img style="width:20px" src="${icon}"/>
                <span style="paddingTop: 10;position: absolute;left:0;top:0;zIndex:998;width: 100%;height: 100%;text-align: center;line-height: 22px;color:#fff;font-size:12px;">${num}</span>
            </div>`;
            return (
                <Tooltip placement={"top"} title={(()=>{
                    switch (checkStatus) {
                        case "change" :
                            return "发现编辑器内容变化，请重新检测";
                        case "loading" :
                            return "检测中请稍后";
                        default :
                            return "单击开始内容检测"
                    }
                })()}>
                    <div
                        style={{
                            position: "relative",
                            cursor:"pointer",
                            display: "inline-block",
                            padding: "10px 10px 0px",
                            verticalAlign: "middle",
                        }}
                        onClick={()=>this.onCheckBtn()}
                    >
                        <img
                            style={{width:20}}
                            src={icon}
                        />
                        <span
                            style={{
                                paddingTop: 10,
                                position: "absolute",left:0,top:0,zIndex:998,
                                width: "100%",height: "100%",
                                textAlign: "center",lineHeight: "22px",
                                color:"#fff", fontSize:12,
                            }}
                        >{num}</span>
                    </div>
                </Tooltip>
            )
        } else {
            return ""
        }
    };

    //开启私信
    showModal = (parms = {},noInfoCheckRecord=[]) => {
        if (parms.isAdd) {
            //新增
            this.state.isUpDate = false;
            this.state.content = '';
            this.state.title = '';
            this.state.summary = '';
            this.state.content = '';//头条内容
            this.state.isUpDate = true;
            this.state.cover = '';//封面图
            this.state.contents = '';//主体内容
            this.state.labelNames = [];//标签名字
            this.state.initWeiBoId = "";
            this.state.timingTransmission = '';//定时发送的时间暂存
        } else {
            //再次编辑头条文章 从微博发布里面点击头条文章图片跳转过来的编辑内容
            this.state.currentData = {...parms};
            this.state.isUpDate = true;
            this.state.initWeiBoId = parms.initWeiBoId;
            this.state.title = parms.touTiaoArticle.title;
            this.state.summary = parms.touTiaoArticle.summary;
            this.state.content = parms.touTiaoArticle.content;//头条内容
            this.state.isUpDate = true;
            this.state.cover = parms.touTiaoArticle.cover;//封面图
            this.state.contents = parms.content;//主体内容
            this.state.labelNames = parms.labelNames;//标签名字
            this.state.timingTransmission = parms.timingTransmission;//定时发送的时间暂存
            this.state.noInfoCheckRecord = noInfoCheckRecord;//定时发送的时间暂存
        }
        //滚动条每次都在最顶部。延迟是为了解决没有this.scrollRef这个的问题
        setTimeout(() => {
            this.scrollRef && this.scrollRef.scrollToTop();
        });
        this.state.visible = true;
        this.setState({})
    };

    handleOk = e => {
        this.handleCancel()
    };

    handleCancel = e => {
        this.setState({
            visible: false,
        });
        if(typeof this.props.handleCancelCall === 'function') {  //解决撤销问题
            this.props.handleCancelCall()
        }
    };

    //下一步
    nextBtn() {
        let content = removeContentSecurity(this.state.content);
        if (this.state.title.trim().length === 0) {
            message.warning('请输入标题！');
            return;
        }
        if (this.state.cover.trim().length === 0) {
            message.warning('请上传封面！');
            return;
        }
        if (content.trim().length === 0 || content.trim() === "<p></p>") {
            message.warning('请输入正文！');
            return;
        }
        this.onCheckSave(()=>{
            this.LinkCheck.show(content,(checkContent)=>{
                console.log("checkContent:", checkContent);
                if(checkContent.status){
                    let parms = {
                        ...this.state.currentData,//复制所有传值，再用下面新的值去覆盖。
                        content: this.state.contents.length > 0 ? this.state.contents : this.state.title,
                        labelNames: this.state.labelNames,//标签名字
                        timingTransmission: this.state.timingTransmission,//定时发送的时间暂存
                        initWeiBoId: this.state.initWeiBoId,//为头条文章带过去的参数；大于0 ，微博编辑的实际微博Id.区别发出去的微博头条，还是新增的微博头条。
                        touTiaoArticle: {
                            content: checkContent.content,
                            cover: this.state.cover,
                            title: this.state.title,
                            summary: this.state.summary,
                        },
                    };
                    let noInfoCheckRecord = [];
                    if(typeof this.securityCheck?.getNoInfoCheckRecord === "function") {
                        noInfoCheckRecord = this.securityCheck.getNoInfoCheckRecord()
                    }
                    this.handleCancel();
                    this.props.callback && this.props.callback(parms,noInfoCheckRecord);
                }
            });
        },);
    }
    // 判定保存后是否需要检测敏感词
    checkActionDecision = () => {
        let needCheckStatus = this.sysConfigGetValueByKey("need.check.status.weibo","已发布");
        return (needCheckStatus &&  needCheckStatus.indexOf("全部")>-1) ? true : false
    };
    onCheckSave = (call) => {
        if(this.checkActionDecision()) {
            this.onCheck((res) => {
                let msg = res?.msg;
                this.checkData = res.data;
                switch (res?.code) {
                    case 0:
                        // 没有敏感词
                        call && call();
                        break;
                    case 1:
                        // 检测到敏感词
                        Modal.confirm({
                            title: "检测到当前微博含有敏感信息",
                            content: "建议返回修改",
                            cancelText: "全部忽略并继续",
                            okText: "返回修改",
                            icon: "exclamation-circle",
                            centered: true,
                            onOk: () => {
                                this.showCheckResult()
                            },
                            onCancel: () => {
                                call && call()
                            },
                        });
                        return false;
                    case -1:
                        // 检测报错
                        message.error(msg || "敏感词检测失败");
                        break;
                    default:
                        // 未知错误
                        message.warning(msg || "敏感词检测失效，无法进行异步检测");
                }
                this.showCheckResult()
            });
        } else {
            call&&call()
        }
    };

    // 展示检测结果
    showCheckResult = () => {
        if(typeof this.securityCheck?.getCheckResult === "function") {
            let {count, checkStatus} = this.securityCheck.getCheckResult(["count", "checkStatus"]);
            let content = removeContentSecurity(this.state.content);
            this.count = count;
            if(this.checkData?.content?.length) {
                // 对敏感词进行排序，长的排前面
                this.checkData.content.sort((a,b)=>b.word.length-a.word.length);
                this.checkData.content.forEach(item=>{
                    let replaceWord = addContentSecurityByText(item?.word);
                    // let reg = `([>][^<]*)${item?.word}([^>]*[<])`;
                    // content = content.replace(new RegExp(reg,"g"),`$1${replaceWord}$2`);
                    content = this.checkWordReplace(content,item?.word,replaceWord);
                })
            }
            this.setState({content,isUpDate:true});
        } else {
            console.log("Error: 检测组件丢失，回显检测结果失败")
        }
    };
    checkWordReplace = (content, word,replaceHtml) => {
        let newTxt = content;
        const regex = /(^|>)[^><]+?(?=$|<)/g;
        return  newTxt.replace(regex, (match) => {
            return match.replace(new RegExp(word,"g"), replaceHtml);
        });
    };
}